export default function CaseStudies() {
  const cases = [
    {
      industry: 'Legal',
      title: 'Legal Operations Streamlined',
      metric: '42%',
      metricLabel: 'reduction',
      description: 'Reduced administrative workload by 42% through structured intake and document automation.',
      color: 'bg-blue-600'
    },
    {
      industry: 'Medical',
      title: 'Medical Practice Optimization',
      metric: '3.5x',
      metricLabel: 'efficiency',
      description: 'Improved scheduling efficiency and internal communication with AI-assisted workflows.',
      color: 'bg-teal-600'
    },
    {
      industry: 'Professional Services',
      title: 'Professional Services Automation',
      metric: '60%',
      metricLabel: 'time saved',
      description: 'Unified fragmented tools into a single intelligent operational system.',
      color: 'bg-purple-600'
    }
  ];

  return (
    <section className="bg-[#F7F9FC] py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="mb-12">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-4 block">Proven Results</span>
          <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Real impact for professional firms
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-8">
          {cases.map((caseStudy, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-10 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
            >
              <div className={`inline-block px-4 py-1.5 rounded-full ${caseStudy.color} text-white text-xs font-semibold mb-6`}>
                {caseStudy.industry}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6 leading-tight">{caseStudy.title}</h3>
              <div className="mb-4">
                <div className="text-5xl font-bold text-[#2B6FED] mb-1" style={{ fontFamily: 'Crimson Pro, serif' }}>
                  {caseStudy.metric}
                </div>
                <div className="text-sm text-gray-500 uppercase tracking-wide">{caseStudy.metricLabel}</div>
              </div>
              <p className="text-base text-gray-600 leading-relaxed mb-6">{caseStudy.description}</p>
              <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-[#2B6FED] group-hover:gap-3 transition-all cursor-pointer">
                Read full case study
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
